type VehicleListType = { id: string; name: string }

export const useUtilsStore = defineStore('utils', () => {
  const vehicleBrands = ref<Array<VehicleListType>>([])
  const vehicleModels = ref<Array<VehicleListType>>([])

  function setVehicleBrands(payload: Array<VehicleListType>) {
    vehicleBrands.value = payload
  }

  function setVehicleModels(payload: Array<VehicleListType>) {
    vehicleModels.value = payload
  }

  return {
    vehicleBrands,
    setVehicleBrands,
    setVehicleModels,
    vehicleModels,
  }
})
